import { Flame, Snowflake } from "@phosphor-icons/react";

const DAYS = ["S", "M", "T", "W", "T", "F", "S"];

export default function StreakTracker({ streak, last7, freezesRemaining = 0, freezesUsedThisMonth = 0 }) {
  const totalFreezes = freezesRemaining + freezesUsedThisMonth;
  const showFreezeStatus = totalFreezes > 0;

  return (
    <div className="card p-6" data-testid="streak-tracker">
      <div className="flex items-center justify-between mb-5">
        <div>
          <p className="eyebrow">Current streak</p>
          <h3 className="font-serif text-3xl mt-1 flex items-center gap-2">
            {streak}
            <span className="text-ink-500 text-base font-sans">
              {streak === 1 ? "day" : "days"}
            </span>
          </h3>
        </div>
        <Flame
          size={32}
          weight={streak > 0 ? "fill" : "light"}
          color={streak > 0 ? "#B75D46" : "#A39E92"}
        />
      </div>
      <div className="flex items-center justify-between gap-2">
        {(last7 || []).map((d, i) => (
          <div key={d.date} className="flex flex-col items-center gap-1.5 flex-1">
            <div
              className={`w-6 h-6 rounded-full border flex items-center justify-center ${
                d.recorded
                  ? "bg-moss border-moss"
                  : d.frozen
                  ? "bg-bone-200 border-brand/30"
                  : "bg-bone-100 border-bone-300"
              }`}
              data-testid={`streak-day-${i}`}
              title={d.frozen ? "Streak Freeze applied — your flame is safe" : undefined}
            >
              {d.frozen && <Snowflake size={11} weight="bold" className="text-brand" />}
            </div>
            <span className="text-[10px] text-ink-500 uppercase tracking-widest">
              {DAYS[new Date(d.date + "T00:00:00").getDay()]}
            </span>
          </div>
        ))}
      </div>
      {showFreezeStatus && (
        <div
          className="mt-5 pt-5 border-t border-bone-300 flex items-center gap-2.5 text-[13px] leading-snug"
          data-testid="streak-freeze-status"
        >
          <Snowflake
            size={16}
            weight={freezesRemaining > 0 ? "fill" : "regular"}
            className={freezesRemaining > 0 ? "text-brand shrink-0" : "text-ink-500 shrink-0"}
          />
          <span className="text-ink-700">
            {freezesRemaining > 0 ? (
              <>
                <b>1 Streak Freeze</b> left this month — we'll auto-protect your flame for one missed day.
              </>
            ) : (
              <>
                Streak Freeze used this month. Resets the 1st.
              </>
            )}
          </span>
        </div>
      )}
    </div>
  );
}
